import { useQuery } from "react-query";
import { fetchAppointment } from "../services/api/appointments";

export default function useAppointment(id: string, enabled: boolean) {
	return useQuery(["Appointments", id], () => fetchAppointment(id), { enabled: enabled });
}
